import React, { useState, useEffect } from 'react';
import { api } from '../services/api';

const LOC = {
  indoor:  { bg:'rgba(99,102,241,0.1)',  color:'#4f46e5' },
  outdoor: { bg:'rgba(5,150,105,0.1)',   color:'#059669' },
  bar:     { bg:'rgba(124,58,237,0.1)',  color:'#7c3aed' },
  terrace: { bg:'rgba(217,119,6,0.1)',   color:'#d97706' },
};

function fmt(t) {
  const [h,m] = t.split(':').map(Number);
  return `${h%12||12}:${String(m).padStart(2,'0')} ${h>=12?'PM':'AM'}`;
}

export default function TableManagement() {
  const [tables, setTables]         = useState([]);
  const [loading, setLoading]       = useState(true);
  const [editing, setEditing]       = useState(null);
  const [ed, setEd]                 = useState({});
  const [saving, setSaving]         = useState(false);
  const [adding, setAdding]         = useState(false);
  const [newTable, setNewTable]     = useState({ label:'', capacity:2, location:'indoor' });
  const [addSaving, setAddSaving]   = useState(false);
  const [viewTable, setViewTable]   = useState(null);
  const [tableResos, setTableResos] = useState([]);
  const [loadingResos, setLoadResos]= useState(false);

  const load = async () => {
    try { setTables(await api.getTables()); } finally { setLoading(false); }
  };
  useEffect(()=>{ load(); },[]);

  const openTableView = async (t) => {
    setViewTable(t);
    setLoadResos(true);
    try {
      const today = new Date().toISOString().slice(0,10);
      const resos = await api.getReservations({ table_id: t.id });
      setTableResos(resos.filter(r => r.date >= today && r.status !== 'cancelled')
        .sort((a,b) => a.date.localeCompare(b.date) || a.time_slot.localeCompare(b.time_slot)));
    } catch(_){ setTableResos([]); } finally { setLoadResos(false); }
  };

  const startEdit = (t, e) => {
    e.stopPropagation();
    setEditing(t.id);
    setEd({label:t.label,capacity:t.capacity,location:t.location,is_active:t.is_active===1});
  };

  const save = async () => {
    setSaving(true);
    try { await api.updateTable(editing,ed); setEditing(null); load(); }
    catch(e){ alert(e.message); } finally { setSaving(false); }
  };

  const toggle = async (t, e) => {
    e.stopPropagation();
    await api.updateTable(t.id,{is_active:t.is_active===1?0:1});
    load();
  };

  const addTable = async () => {
    if (!newTable.label.trim()) return alert('Label required');
    setAddSaving(true);
    try {
      await api.createTable(newTable);
      setAdding(false);
      setNewTable({ label:'', capacity:2, location:'indoor' });
      load();
      window.dispatchEvent(new CustomEvent('seva:refresh'));
    } catch(e){ alert(e.message); } finally { setAddSaving(false); }
  };

  if (loading && tables.length === 0) return <div style={{color:'var(--text-muted)',padding:40}}>Loading tables…</div>;

  return (
    <div>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:6}}>
        <h1 style={s.h1}>Tables</h1>
        <button style={s.addBtn} onClick={()=>setAdding(a=>!a)}>+ Add Table</button>
      </div>
      <p style={s.sub}>Click any table to see its upcoming reservations. Deactivate tables to hide them from AI booking.</p>

      {adding && (
        <div style={s.addForm}>
          <div style={{display:'flex',gap:12,flexWrap:'wrap',alignItems:'flex-end'}}>
            <div style={s.eRow}>
              <label style={s.eLabel}>Label</label>
              <input style={{...s.eInput,width:120}} className="glass-input" placeholder="e.g. T1" value={newTable.label} onChange={e=>setNewTable(d=>({...d,label:e.target.value}))} autoFocus />
            </div>
            <div style={s.eRow}>
              <label style={s.eLabel}>Capacity</label>
              <input style={{...s.eInput,width:70}} className="glass-input" type="number" min="1" value={newTable.capacity} onChange={e=>setNewTable(d=>({...d,capacity:parseInt(e.target.value)||1}))} />
            </div>
            <div style={s.eRow}>
              <label style={s.eLabel}>Location</label>
              <select style={{...s.eInput,width:110}} className="glass-input" value={newTable.location} onChange={e=>setNewTable(d=>({...d,location:e.target.value}))}>
                {['indoor','outdoor','bar','terrace'].map(l=><option key={l} value={l}>{l}</option>)}
              </select>
            </div>
            <div style={{display:'flex',gap:8,marginBottom:12}}>
              <button style={s.saveBtn} onClick={addTable} disabled={addSaving}>{addSaving?'…':'Save'}</button>
              <button style={s.discBtn} onClick={()=>setAdding(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      <div style={s.grid}>
        {tables.map(t => {
          const loc = LOC[t.location] || { bg:'rgba(0,0,0,0.06)', color:'var(--text-secondary)' };
          const active = t.is_active===1;

          if (editing===t.id) return (
            <div key={t.id} style={s.card} onClick={e=>e.stopPropagation()}>
              <div style={s.eRow}>
                <label style={s.eLabel}>Label</label>
                <input style={s.eInput} className="glass-input" value={ed.label} onChange={e=>setEd(d=>({...d,label:e.target.value}))} />
              </div>
              <div style={s.eRow}>
                <label style={s.eLabel}>Capacity</label>
                <input style={s.eInput} className="glass-input" type="number" min="1" value={ed.capacity} onChange={e=>setEd(d=>({...d,capacity:parseInt(e.target.value)}))} />
              </div>
              <div style={s.eRow}>
                <label style={s.eLabel}>Location</label>
                <select style={s.eInput} className="glass-input" value={ed.location} onChange={e=>setEd(d=>({...d,location:e.target.value}))}>
                  {['indoor','outdoor','bar','terrace'].map(l=><option key={l} value={l}>{l}</option>)}
                </select>
              </div>
              <label style={{...s.eLabel,display:'flex',alignItems:'center',gap:8,marginBottom:16,cursor:'pointer'}}>
                <input type="checkbox" checked={ed.is_active} onChange={e=>setEd(d=>({...d,is_active:e.target.checked}))} />
                Active (visible to AI)
              </label>
              <div style={{display:'flex',gap:8}}>
                <button style={s.saveBtn} className="glass-btn t" onClick={save} disabled={saving}>{saving?'…':'Save'}</button>
                <button style={s.discBtn} className="glass-btn t" onClick={()=>setEditing(null)}>Cancel</button>
              </div>
            </div>
          );

          return (
            <div key={t.id} style={{...s.card,...(!active?s.dimCard:{})}} className="glass-card-hover t"
              onClick={()=>openTableView(t)}>
              <div style={s.cardTop}>
                <span style={s.tLabel}>{t.label}</span>
                {!active && <span style={s.inactivePill}>Inactive</span>}
              </div>
              <div style={s.tCap}>{t.capacity} seats</div>
              <span style={{...s.locPill,...loc}}>{t.location}</span>
              <div style={s.cardBtns}>
                <button style={s.editBtn} className="t" onClick={e=>startEdit(t,e)}>Edit</button>
                <button style={active?s.deactBtn:s.actBtn} className="t" onClick={e=>toggle(t,e)}>
                  {active?'Deactivate':'Activate'}
                </button>
              </div>
            </div>
          );
        })}
      </div>

      {viewTable && (
        <div style={s.overlay} onClick={()=>setViewTable(null)}>
          <div style={s.modal} onClick={e=>e.stopPropagation()}>
            <div style={s.modalTop}>
              <div>
                <h2 style={s.modalTitle}>{viewTable.label}</h2>
                <div style={s.modalSub}>{viewTable.capacity} seats · {viewTable.location}</div>
              </div>
              <button style={s.closeBtn} onClick={()=>setViewTable(null)}>×</button>
            </div>
            <div style={s.divider} />

            {loadingResos ? (
              <div style={{color:'var(--text-muted)',padding:'20px 0'}}>Loading…</div>
            ) : tableResos.length === 0 ? (
              <div style={s.noResos}>
                <div style={{fontSize:32,marginBottom:8}}>✅</div>
                <div>No upcoming reservations for this table</div>
              </div>
            ) : (
              <div style={s.resoList}>
                <div style={s.resoHeader}>Upcoming reservations ({tableResos.length})</div>
                {tableResos.map(r => (
                  <div key={r.id} style={s.resoRow}>
                    <div style={s.resoDate}>
                      <div style={s.resoDateMain}>{new Date(r.date+'T12:00:00Z').toLocaleDateString('en-US',{weekday:'short',month:'short',day:'numeric',timeZone:'UTC'})}</div>
                      <div style={s.resoTime}>{fmt(r.time_slot)}</div>
                    </div>
                    <div style={s.resoInfo}>
                      <div style={s.resoName}>{r.customer_name}</div>
                      <div style={s.resoMeta}>
                        <span style={s.chip}>{r.party_size} guests</span>
                        {r.tables_display && r.tables_display !== r.table_label &&
                          <span style={{...s.chip,background:'rgba(124,58,237,0.1)',color:'#6d28d9'}}>Combined: {r.tables_display}</span>}
                        {r.source==='ai' && <span style={{...s.chip,background:'rgba(124,58,237,0.1)',color:'#6d28d9',fontWeight:700}}>AI</span>}
                      </div>
                      {r.special_requests && <div style={s.resoNote}>{r.special_requests}</div>}
                    </div>
                    <div style={{...s.statusDot,background:r.status==='confirmed'?'#10b981':'#f59e0b'}} title={r.status} />
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

const s = {
  h1:          { fontSize:28, fontWeight:800, color:'var(--text-primary)', margin:0, letterSpacing:'-0.5px' },
  addBtn:      { background:'var(--accent)', border:'none', borderRadius:10, padding:'9px 18px', fontSize:13, fontWeight:700, color:'#fff', cursor:'pointer' },
  addForm:     { background:'var(--section-bg)', border:'1px solid var(--section-border)', borderRadius:14, padding:'18px 20px', marginBottom:20 },
  sub:         { fontSize:14, color:'var(--text-muted)', marginTop:4, marginBottom:26 },
  grid:        { display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(168px,1fr))', gap:14 },
  card:        { background:'#ffffff', border:'1px solid #e2e8f0', borderRadius:18, padding:'18px 20px', display:'flex', flexDirection:'column', gap:8, cursor:'pointer', boxShadow:'0 1px 3px rgba(15,23,42,0.05)' },
  dimCard:     { opacity:0.5 },
  cardTop:     { display:'flex', alignItems:'center', justifyContent:'space-between' },
  tLabel:      { fontSize:22, fontWeight:800, color:'var(--text-primary)' },
  inactivePill:{ background:'#fef2f2', color:'#dc2626', borderRadius:20, padding:'2px 8px', fontSize:10, fontWeight:700, border:'1px solid #fecaca' },
  tCap:        { fontSize:13, color:'var(--text-muted)' },
  locPill:     { display:'inline-block', borderRadius:6, padding:'3px 10px', fontSize:11, fontWeight:600, width:'fit-content' },
  cardBtns:    { display:'flex', gap:6, marginTop:4 },
  editBtn:     { flex:1, background:'var(--section-bg)', border:'1px solid var(--section-border)', borderRadius:8, padding:'7px', cursor:'pointer', fontSize:12, color:'var(--text-secondary)' },
  deactBtn:    { flex:1, background:'#fef2f2', border:'1px solid #fecaca', borderRadius:8, padding:'7px', cursor:'pointer', fontSize:12, color:'#dc2626' },
  actBtn:      { flex:1, background:'#f0fdf4', border:'1px solid #bbf7d0', borderRadius:8, padding:'7px', cursor:'pointer', fontSize:12, color:'#15803d' },
  eRow:        { display:'flex', flexDirection:'column', gap:4, marginBottom:12 },
  eLabel:      { fontSize:11, fontWeight:700, color:'var(--text-muted)', textTransform:'uppercase', letterSpacing:'0.05em' },
  eInput:      { background:'var(--input-bg)', border:'1px solid var(--input-border)', borderRadius:8, padding:'7px 10px', fontSize:13, outline:'none', color:'var(--input-text)' },
  saveBtn:     { flex:1, background:'var(--accent)', border:'none', borderRadius:8, padding:'9px', cursor:'pointer', fontSize:13, color:'#fff', fontWeight:700 },
  discBtn:     { flex:1, background:'var(--section-bg)', border:'1px solid var(--section-border)', borderRadius:8, padding:'9px', cursor:'pointer', fontSize:13, color:'var(--text-secondary)' },

  overlay:     { position:'fixed', inset:0, background:'rgba(15,23,42,0.45)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:500 },
  modal:       { background:'#ffffff', border:'1px solid #e2e8f0', borderRadius:22, padding:30, width:540, maxWidth:'90vw', maxHeight:'80vh', overflow:'auto', boxShadow:'0 20px 60px rgba(15,23,42,0.18)' },
  modalTop:    { display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:18 },
  modalTitle:  { fontSize:22, fontWeight:800, color:'var(--text-primary)', margin:'0 0 4px' },
  modalSub:    { fontSize:13, color:'var(--text-muted)' },
  closeBtn:    { background:'var(--section-bg)', border:'1px solid var(--section-border)', borderRadius:8, width:32, height:32, fontSize:20, cursor:'pointer', color:'var(--text-secondary)', flexShrink:0 },
  divider:     { height:1, background:'var(--divider)', margin:'0 0 18px' },
  noResos:     { textAlign:'center', padding:'32px 0', color:'var(--text-muted)', fontSize:14 },
  resoList:    { display:'flex', flexDirection:'column', gap:0 },
  resoHeader:  { fontSize:10, fontWeight:700, color:'var(--text-muted)', textTransform:'uppercase', letterSpacing:'0.08em', marginBottom:12 },
  resoRow:     { display:'flex', gap:16, alignItems:'flex-start', padding:'13px 0', borderBottom:'1px solid var(--divider)' },
  resoDate:    { width:90, flexShrink:0 },
  resoDateMain:{ fontSize:13, fontWeight:700, color:'var(--text-primary)' },
  resoTime:    { fontSize:12, color:'var(--text-muted)', marginTop:2 },
  resoInfo:    { flex:1 },
  resoName:    { fontSize:14, fontWeight:600, color:'var(--text-secondary)', marginBottom:4 },
  resoMeta:    { display:'flex', gap:6, flexWrap:'wrap' },
  chip:        { background:'var(--chip-bg)', color:'var(--chip-text)', borderRadius:6, padding:'2px 8px', fontSize:11, fontWeight:600 },
  resoNote:    { fontSize:12, color:'var(--text-muted)', marginTop:4 },
  statusDot:   { width:8, height:8, borderRadius:'50%', flexShrink:0, marginTop:4 },
};
